import { render } from "./GatewayExplanationSlides.vue?vue&type=template&id=02b60340&scoped=true"
import script from "./GatewayExplanationSlides.vue?vue&type=script&lang=js"
export * from "./GatewayExplanationSlides.vue?vue&type=script&lang=js"

import "./GatewayExplanationSlides.vue?vue&type=style&index=0&id=02b60340&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-02b60340"

export default script